import { Component, ViewChild } from '@angular/core';
import { ManageTagsIndexTable } from '@documents-v2/services/tables/manage-tags-index/manage-tags-index.table';
import { ConfirmationDialogComponent } from '@app/components';
import { DocumentTagForm } from '@forms/documents/components';
import { DocumentTag } from '@models/documents/document-tag.model';
import { NotifyService } from '@app/services';
import { MenuColumnEvent } from '@table/interfaces/menu-column-event.interface';

@Component({
    templateUrl: './manage-tags.template.html',
})
export class ManageTagsView {
    @ViewChild('documentTagForm') documentTagForm!: DocumentTagForm;
    @ViewChild('confirmDeleteTagDialog') confirmDeleteTagDialog!: ConfirmationDialogComponent;

    isLoading = false;
    documentTagFormOpen = false;
    tagNameToDelete: string | null = null;

    constructor(
        public table: ManageTagsIndexTable,
        private notify: NotifyService
    ) {
        this.table.reload();
    }

    menuAction(event: MenuColumnEvent): void {
        const { menuItem, data } = event;
        const tag = data as DocumentTag;

        switch (menuItem.event) {
            case 'rename':
                this.renameTag(tag);
                break;
            case 'delete':
                this.deleteTag(tag);
                break;
        }
    }

    renameTag(tag: DocumentTag): void {
        this.documentTagForm.documentTag = tag;
        this.documentTagFormOpen = true;
    }

    async onSaveDocumentTag(form: DocumentTagForm): Promise<void> {
        this.isLoading = true;
        const documentTag = form.documentTag;

        try {
            await documentTag.save();
            this.table.reload();
            form.reset();
            this.notify.success('document.tagSaved');
        } catch (e) {
            documentTag.revert();
            this.notify.error(e);
        }

        this.isLoading = false;
        this.documentTagFormOpen = false;
    }

    async deleteTag(tag: DocumentTag): Promise<void> {
        this.tagNameToDelete = tag.name;
        const response = await this.confirmDeleteTagDialog.open();

        if (!response) {
            return;
        }

        try {
            this.isLoading = true;
            await tag.delete();
            this.table.reload();
            this.notify.success('document.tagDeleted');
        } catch (e) {
            this.notify.error(e);
        }

        this.isLoading = false;
    }
}
